<template>
  <div id="buyer_center">
    <div class="buyer-title">
      <div class="title-left">
        <i class="title-icon el-icon-document-checked"></i>
        商品详情
      </div>
      <div class="title-right">
        <span class="after-sale-btn" @click="goAfterSales" v-if="buyOrderDetail.order_status_for_user === 3 && [1, 2].includes(buyOrderDetail.after_sale_status)">{{ afterSalesBtnText }}</span>
        <router-link :to="{ name: type == 1 ? 'Buyer' : 'BuyerEquip' }"
          >返回</router-link
        >
      </div>
    </div>
    <div class="buyer_main">
      <div class="info-section">
        <div class="buyer_main_title">订单详情</div>
        <div class="table-row">
          <el-table :data="tableData" border class="detail-table">
            <el-table-column
              v-for="item in tableColumn"
              :label="item.label == '订单应付金额'? textChange: item.label"
              :min-width="item.minWidth"
              :prop="item.prop"
              align="center"
              :class-name="
                ['order_amount_total', 'product_coupon_amount', 'indemnity_coupon_amount', 'order_amount'].includes(item.prop)
                  ? 'amount-cell'
                  : item.prop === 'order_status_for_user'
                  ? 'status-cell'
                  : ''
              "
              :key="item.id"
            >
              <template slot-scope="scope">
                <template v-if="item.prop === 'order_status_for_user'">
                  {{
                    scope.row.order_status_for_user == 1
                      ? "待付款"
                      : scope.row.order_status_for_user == 2
                      ? "待发货"
                      : scope.row.order_status_for_user == 3
                      ? "已成交"
                      : scope.row.order_status_for_user == 4
                      ? "已取消"
                      : scope.row.order_status_for_user == 5
                      ? "退款中"
                      : "已退款"
                  }}
                </template>
                <template v-else>{{ scope.row[item.prop] }}</template>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="支付方式">
            <template slot-scope="scope">
              {{scope.row.pay_method==1?'全款':scope.row.pay_method==2?'垫付':scope.row.pay_method==3?'代付分期':'普通分期'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="支付期数" v-if="pay_method!=1">
            <template slot-scope="scope">
              {{scope.row.periods}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="成功付款" v-if="pay_method!=1">
            <template slot-scope="scope">
              {{scope.row.actual_receipt_nums}}次
            </template>
          </el-table-column> -->
          <!-- <el-table-column align="center" label="完成备注" min-width="200">
            <template slot-scope="scope">
              {{scope.row.description}}
            </template>
          </el-table-column> -->
          </el-table>
          <!--        <el-table :data="indemnityList" border class="no-border-left" v-if="indemnityTableShow">-->
          <!--          <el-table-column v-for="(item) in indemnityColumn" :min-width="item.minWidth" :label="item.label" :prop="item.prop" align="center" :key="item.id">-->
          <!--          </el-table-column>-->
          <!--        </el-table>-->
        </div>
      </div>

      <div class="info-section">
        <div class="buyer_main_title shop_info">包赔服务</div>
        <el-table :data="indemnityList" border class="detail-table">
          <el-table-column
            v-for="item in indemnityColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'amount'
                ? 'amount-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'description'" style="text-align:left;">
                {{ scope.row.description }}
              </div>
              <div v-else-if="item.prop === 'amount'">
                ¥ {{ scope.row.amount }}
              </div>
              <div v-else-if="item.prop === 'percent_compensation'">
                {{ scope.row.percent_compensation }}%
              </div>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title shop_info">订单商品信息</div>
        <el-table :data="orderData" border class="detail-table">
          <el-table-column
            v-for="item in orderColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'amount'
                ? 'amount-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'goods_name'" style="text-align:left;">
                {{ scope.row.goods_name }}
              </div>
              <div v-else-if="item.prop === 'amount'">
                ¥{{ scope.row.amount }}
              </div>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品协商价" align="center" min-width="110" class-name="amount-cell">
            <template slot-scope="scope">
              ￥{{
                scope.row.negotiate_price > 0
                  ? scope.row.negotiate_price
                  : scope.row.amount
              }}
            </template>
          </el-table-column>
          <el-table-column label="商品活动价" align="center" min-width="110" class-name="amount-cell" v-if="orderData[0] && orderData[0].activity_price>0">
            <template slot-scope="scope">
              ￥{{
              scope.row.activity_price
              }}
            </template>
          </el-table-column>
          <el-table-column label="查看详情" align="center" min-width="110">
            <template slot-scope="scope">
              <div class="checkDetails" @click="checkDetails(scope.row)">
                查看详情
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title shop_info">优惠券信息</div>
        <el-table :data="couponData" border class="detail-table">
          <el-table-column label="优惠券类型" prop="coupon_type" align="center">
          </el-table-column>
          <el-table-column label="优惠券名称" prop="coupon_name" align="center">
          </el-table-column>
          <el-table-column label="使用门槛" prop="threshold" align="center">
          </el-table-column>
          <el-table-column label="优惠金额" prop="amount" align="center" class-name="amount-cell">
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title shop_info">付款详情</div>
        <el-table :data="payData" border class="detail-table">
          <el-table-column
            v-for="item in payColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'actual_amount'
                ? 'amount-cell'
                : item.prop === 'inv_status_for_user'
                ? 'status-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'inv_status_for_user'">
                {{
                  scope.row.inv_status_for_user == 1
                    ? "处理中"
                    : scope.row.inv_status_for_user == 2
                    ? "付款成功"
                    : "付款失败"
                }}
              </div>
              <div v-else-if="item.prop === 'add_time'">
                {{ $formatDate(scope.row.add_time) }}
              </div>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section" v-if="order_status_for_user == 5 || order_status_for_user == 6">
        <div class="buyer_main_title shop_info">退款详情</div>
        <el-table
          :data="refundData"
          border
          class="detail-table"
          v-if="order_status_for_user == 5 || order_status_for_user == 6"
        >
          <el-table-column
            v-for="item in refundColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'actual_amount'
                ? 'amount-cell'
                : item.prop === 'inv_status_for_user'
                ? 'status-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'inv_status_for_user'">
                {{
                  scope.row.inv_status_for_user == 1
                    ? "处理中"
                    : scope.row.inv_status_for_user == 2
                    ? "退款成功"
                    : "退款失败"
                }}
              </div>
              <div v-else-if="item.prop === 'add_time'">
                {{ $formatDate(scope.row.add_time) }}
              </div>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 申请售后弹窗 -->
    <myDialog
      title="售后原因"
      btn-text="提交"
      btn
      dialog-style="header"
      :show-close="true"
      :close-btn-show="false"
      :show="afterSalesDialog"
      :btn-fuc="afterSalesDialogConfirm"
      :close-fun="() => {
      afterSalesDialog = false
    }">
      <div slot="content" class="after-sales-dialog-cont">
        <span :class="{ 'active-item': afterSalesType === 2 }" @click="afterSalesType = 2">交易纠纷</span>
        <span :class="{ 'active-item': afterSalesType === 1 }" @click="afterSalesType = 1">找回问题</span>
      </div>
    </myDialog>
    <!-- 售后详情弹窗 -->
    <myDialog
      title="售后记录"
      :btn-text="afterSaleDetailBtnText"
      btn
      width="422"
      dialog-style="header"
      :show-close="true"
      :close-btn-show="false"
      box-padding="24px 32px 30px"
      :show="afterSalesDetailDialog"
      :btn-fuc="afterSalesDetailDialogConfirm"
      :close-fun="() => {
      afterSalesDetailDialog = false
    }">
      <div slot="content" class="after-sales-detail-cont custom-scroll-y">
        <PxTimeline :list="timelineList" :step="timelineList.length" />
      </div>
    </myDialog>
  </div>
</template>
<script>
import { apiBuyOrderDetail, afterSaleIntoRoomApi, afterSaleDetailApi } from "@/request/API";
import myDialog from "@/components/myDialog";
import PxTimeline from "../../../components/PxTimeline.vue";

export default {
  name: "BuyerDetail",
  props: {},
  components: { myDialog, PxTimeline },
  data() {
    return {
      // 售后详情数据
      afterSaleDetail: {},
      afterSalesDetailDialog: false,
      buyOrderDetail: {},
      // 2-交易纠纷  1-找回问题
      afterSalesType: 2,
      afterSalesDialog: false,
      timelineList: [],
      id: "",
      type: "",
      pay_method: "",
      order_status_for_user: "",
      tableData: [],
      tableColumn: [
        { label: "订单编号", prop: "order_no", minWidth: 120 },
        { label: "订单金额", prop: "order_amount_total" },
        { label: "账号优惠券", prop: "product_coupon_amount" },
        { label: "包赔优惠券", prop: "indemnity_coupon_amount" },
        { label: "订单应付金额", prop: "order_amount" },
        { label: "订单状态", prop: "order_status_for_user" }
      ],
      orderData: [],
      couponData: [],
      orderColumn: [
        { label: "商品编号", prop: "unique_no" },
        { label: "商品名称", prop: "goods_name", minWidth: 400 },
        { label: "游戏名称", prop: "game_name" },
        { label: "商品金额", prop: "amount" }
        // { label: '游戏账号信息', prop: 'account',minWidth:120},
      ],
      payData: [],
      payColumn: [
        { label: "付款编号", prop: "inv_no" },
        // { label: '应付金额', prop: 'amount'},
        { label: "付款金额", prop: "actual_amount" },
        { label: "付款状态", prop: "inv_status_for_user" },
        { label: "付款时间", prop: "add_time" }
      ],
      refundData: [],
      refundColumn: [
        { label: "退款编号", prop: "inv_no" },
        // { label: '应退金额', prop: 'amount'},
        { label: "退款金额", prop: "actual_amount" },
        { label: "退款状态", prop: "inv_status_for_user" },
        { label: "退款时间", prop: "add_time" }
      ],
      indemnityList: [],
      indemnityColumn: [
        { label: "包赔名称", prop: "title" },
        { label: "包赔价格", prop: "amount" },
        { label: "赔付比例", prop: "percent_compensation" },
        { label: "包赔说明", prop: "description", minWidth: 400 }
      ],
      indemnityTableShow: true,
      textChange: '订单应付金额'
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.t;
    apiBuyOrderDetail({
      order_id: this.id
    }).then(res => {
      this.buyOrderDetail = res.data || {}
      this.order_status_for_user = res.data.order_status_for_user;
      if(this.order_status_for_user==1 || this.order_status_for_user==4){
          this.textChange = '订单应付金额'
        } else {
          this.textChange = '订单实付金额'
        }
      this.tableData = [{ ...res.data }].map(v=>{
        v.order_amount_total = (Number(v.order_amount) + Number(v.product_coupon_amount) + Number(v.indemnity_coupon_amount)).toFixed(2)
        return v
      })
      this.pay_method = res.data.pay_method;
      this.orderData = res.data.order_info;
      this.couponData = res.data.coupon_info.map(v => {
        switch (v.coupon_type) {
          case 1:
            v.coupon_type = "商品优惠券";
            break;
          case 2:
            v.coupon_type = "包赔优惠券";
            break;
          case 3:
            v.coupon_type = "诚心卖优惠券";
            break;
          default:
            break;
        }
        v.threshold = `满${v.threshold}元使用`
        return v
      });
      this.payData = res.data.receipt_invoice_info_list;
      this.refundData = res.data.refund_invoice_info_list;
      this.indemnityList = res.data.indemnity;
      // let indemnity = res.data.indemnity
      this.indemnityTableShow = this.indemnityList.length > 0;
      /*      let inde = {}
      indemnity.forEach((item, index) => {
        let i = index +1
        inde['baopei'+i] = item.title
        this.indemnityColumn.push({
          label : '包赔信息' + i,
          prop : 'baopei' + i
        })
      })
      this.indemnityList = [inde]*/
    });
  },
  methods: {
    // 售后弹出
    goAfterSales() {
      // 申请售后
      if (this.buyOrderDetail.after_sale_status === 1) {
        this.afterSalesDialog = true
        return
      }
      // 售后详情
      if (this.buyOrderDetail.after_sale_status === 2) {
        afterSaleDetailApi({
          order_id: this.id
        }).then(res => {
          this.afterSaleDetail = res.data || {}
          this.timelineList = res.data.list
          this.afterSalesDetailDialog = true
        })
      }
    },
    // 售后确认
    afterSalesDialogConfirm() {
      const {unique_no, order_no, game_id} = this.buyOrderDetail.order_info[0] || {}
      afterSaleIntoRoomApi({
        order_id: this.buyOrderDetail.id,
        type: this.afterSalesType
      }).then(res => {
        if(res.code === 200) {
          this.$openIM({
            afterSalesType: this.afterSalesType,
            gameId: game_id,
            unique_no,
            order_no,
            roomId: res.data.room_id
          })
          // 变更按钮状态
          this.buyOrderDetail.after_sale_status = 2
        }
      }).catch(err => this.$message.error(err.msg))
      this.afterSalesDialog = false
    },
    // 售后详情确认
    afterSalesDetailDialogConfirm() {
      const status = this.afterSaleDetail.after_sale_status
      if(status === 2) {
        this.$openIM({
          im_type: 3,
          roomId: this.afterSaleDetail.room_id,
          gameId: this.buyOrderDetail.game_id
        })
      }
      if(status === 1) {
        this.afterSalesDetailDialog = false
        this.afterSalesDialog = true
      }
    },
    /**
     * 查看商品详情
     */
    checkDetails(row) {
      this.$router.push({
        name: "SellerDetail",
        query: {
          game_id: row.game_id,
          order_id: row.order_id,
          id: row.goods_id
        }
      });
    }
  },
  mounted() {},
  watch: {},
  computed: {
    afterSalesBtnText() {
      const status = this.buyOrderDetail.after_sale_status
      return status === 1 ? '申请售后' : status === 2 ? '售后详情' : ''
    },
    afterSaleDetailBtnText() {
      const status = this.afterSaleDetail.after_sale_status
      return status === 1 ? '重新申请' : status === 2 ? '进入群聊' : ''
    }
  }
};
</script>
<style lang="less" scoped>
.after-sales-detail-cont {
  overflow-y: scroll;
  margin: 20px 0;
  max-height: 180px;
}

.after-sales-dialog-cont {
  display: flex;
  width: 100%;
  gap: 12px;
  margin: 2px 0 24px;

  span {
    display: flex;
    width: 140px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-tag, #F7F5F2);
    color: var(--text-secondary, #5A5F6B);
    font-family: PingFang SC-Regular, PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color .2s ease, color .2s ease, background .2s ease, box-shadow .2s ease;
  }

  span:hover {
    border-color: var(--primary, #FF5A1F);
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);
  }

  .active-item {
    border-color: var(--primary, #FF5A1F);
    font-weight: 500;
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);
    box-shadow: none;
  }
}

#buyer_center {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: transparent;
  color: var(--text-main, #111827);

  .buyer-title {
    display: flex;

    padding: 0 28px;
    min-height: 72px;

    font-family: PingFang SC, PingFang SC-Medium;
    font-size: 20px;
    font-weight: 500;

    color: #fff;
    background: var(--bg-dark, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));

    align-items: center;
    justify-content: space-between;

    .title-left {
      display: flex;

      align-items: center;
      justify-content: flex-start;

      .title-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px 0 0;
        border-radius: 4px;
        width: 34px;
        height: 34px;
        background: rgba(255, 255, 255, .16);
        font-size: 18px;
      }
    }

    .title-right {
      display: flex;
      align-items: center;

      .after-sale-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        margin-right: 12px;
        border: 1px solid rgba(255, 255, 255, .38);
        border-radius: 4px;
        min-width: 90px;
        height: 34px;
        padding: 0 14px;

        font-size: 14px;
        font-weight: 500;
        line-height: 32px;
        text-align: center;

        color: #fff;
        background: rgba(255, 255, 255, .14);

        cursor: pointer;
        transition: all .2s ease;
      }

      .after-sale-btn:hover {
        background: rgba(255, 255, 255, .22);
        border-color: rgba(255, 255, 255, .68);
      }

      a {
        display: flex;
        align-items: center;
        height: 34px;
        padding: 0 14px;
        border: 1px solid rgba(255, 255, 255, .38);
        border-radius: 4px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 32px;

        color: #fff;
        transition: all .2s ease;
      }

      a:hover {
        background: rgba(255, 255, 255, .14);
        border-color: rgba(255, 255, 255, .68);
      }
    }
  }

  .buyer_main {
    padding: 22px 28px 28px;
    background: var(--bg-card, #FFFFFF);

    .info-section {
      padding: 18px 20px 20px;
      margin: 0 0 18px;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .buyer_main_title {
      display: flex;

      margin-bottom: 18px;

      font-family: PingFang SC-Medium, PingFang SC;
      font-size: 18px;
      font-weight: 500;

      color: var(--text-main, #111827);

      align-items: center;
      justify-content: flex-start;

      &::before {
        display: inline-block;

        margin-right: 12px;
        border-radius: 4px;
        width: 4px;
        height: 18px;

        background: var(--primary, #FF5A1F);

        content: "";
      }
    }

    .shop_info {
      margin-top: 0;
    }

    .checkDetails {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      height: 30px;
      padding: 0 12px;
      border: 1px solid rgba(255, 122, 26, .2);
      border-radius: 4px;
      color: var(--primary, #FF7A1A);
      background: var(--primary-soft, #FFF3E7);
      font-weight: 500;

      cursor: pointer;
      transition: all .2s ease;
    }

    .checkDetails:hover {
      border-color: rgba(255, 122, 26, .36);
      color: var(--primary-hover, #F97316);
      background: #FFE8D2;
    }

    .table-row {
      display: flex;
    }

    .detail-table {
      min-height: 88px;
      border-color: var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;

      /deep/ &::before,
      /deep/ &::after {
        background-color: var(--border-soft, #E8E4DE);
      }

      /deep/ th {
        height: 48px;
        background: var(--bg-tag, #F7F5F2);
        border-color: var(--border-soft, #E8E4DE);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500 !important;
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ td {
        height: 54px;
        border-color: var(--border-soft, #E8E4DE);
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #111827);
      }

      /deep/ .el-table__body tr:hover > td {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-table__empty-block {
        min-height: 88px;
      }

      /deep/ .el-table__empty-text {
        color: var(--text-muted, #9AA0AC);
      }

      /deep/ .el-table__body td.amount-cell {
        color: var(--primary, #FF7A1A);
        font-weight: 500;
      }

      /deep/ .el-table__body td.status-cell .cell {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 68px;
        height: 28px;
        padding: 0 12px;
        border: 1px solid rgba(26, 29, 36, .12);
        border-radius: 4px;
        background: var(--bg-tag, #F0EDE8);
        color: var(--text-main, #1A1D24);
        font-size: 13px;
        line-height: 26px;
      }
    }

    /deep/ th {
      font-weight: 500 !important;
    }
  }

  .no-border-left {
    border-left: none;
  }
}


</style>
